// SPDX-License-Identifier: GPL-3.0-or-later

// Конфиг читается из Vite env: .env.production / .env.development / стенд-специфичные.
// Все переменные — VITE_* иначе Vite их не пробросит в bundle.

export interface ClientConfig {
  signalingHost: string;
  signalingPort: number;
  signalingSecure: boolean;
  signalingPath: string;
  credentialsBaseUrl: string;
}

export function loadClientConfig(): ClientConfig {
  const env = (import.meta as unknown as { env?: Record<string, string | undefined> }).env ?? {};
  return {
    signalingHost: env.VITE_SIGNALING_HOST ?? 'localhost',
    signalingPort: Number(env.VITE_SIGNALING_PORT ?? 9000),
    signalingSecure: (env.VITE_SIGNALING_SECURE ?? 'false') === 'true',
    signalingPath: env.VITE_SIGNALING_PATH ?? '/peerjs',
    credentialsBaseUrl: env.VITE_CREDENTIALS_BASE_URL ?? 'http://localhost:9000',
  };
}
